<template>
<div>
  <div>
    <div class="columns">
      <pager class="pl" :pageable="users" @nav="loadUsers" :context="Naming.User.toLowerCase()"/>
      <div class="column">
        <table class="table is-fullwidth is-vcentered is-hoverable">
          <thead class="is-sticky">
            <tr>
              <th>Full Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users.data" :key="user.id">
              <td>
                <link-user-overview avatar :user="user"/>
              </td>
              <td>
                <span v-if="user.profile">{{ user.profile.formatted_mobile }}</span>
              </td>
              <td>{{ user.email }}</td>
              <td>
                <yes-no :value="user.active"/>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="has-text-centered" v-if="!users.data.length">
          No {{ Naming.Users }} found
        </p>
        <pager class="pl" :pageable="users" @nav="loadUsers" :context="Naming.User.toLowerCase()"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { createAdmin } from '@/modals'

export default {

  data: () => ({
    loading: true,
  }),

  async created() {
    await this.loadUsers()
    this.loading = false
  },

  methods: {
    loadUsers() {
      this.$scrollToTop()
      return this.$store.dispatch('user/loadUsers', {
        path: '/api' + this.$route.fullPath
      })
    },
    goToPage(path) {
      this.$router.push(path)
    },
    addAdmin() {
      createAdmin().then(reload => {
        if(reload) this.loadUsers()
      })
    }
  },

  computed: {
    ...mapGetters('user', [
      'users'
    ]),
    ...mapGetters('auth', [
      'isOutOfTimeZone'
    ])
  },

  watch: {
    '$route': 'loadUsers'
  }
}
</script>
